import { QCCategory } from 'app/common/services/SmartQC.service';

export enum FormFieldCode {
  NAME = 'name',
  DESCRIPTION = 'description',
}

export function buildCreateQCCategoryModel() {
  return {
    [FormFieldCode.NAME]: '',
    [FormFieldCode.DESCRIPTION]: null,
  };
}

export function buildEditQCCategoryModel(qcCategory: QCCategory) {
  return {
    [FormFieldCode.NAME]: qcCategory.name,
    [FormFieldCode.DESCRIPTION]: qcCategory.description || null,
  };
}

export function buildTableColumns() {
  return [
    {
      title: 'Tên',
      key: 'name',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Mô tả',
      key: 'description',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
  ];
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/smart-qc/setting/category/setting-category.util.ts